import React from 'react';
import { STATUS_COLOR_PALETTE } from './statusColorPalette';

/**
 * Celula das abas de Acompanhamento de Arquivos: check quando o projeto possui o registro
 * daquele tipo de ajuste, x quando nao possui. Mais de um registro mostra a quantidade (2x, 3x)
 * para evidenciar duplicidade.
 */
export const monitoringCheckCell = (total) => {
    const count = Number(total) || 0;
    const hasRecord = count > 0;

    return (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i
                className={hasRecord ? 'fas fa-check-circle' : 'fas fa-times-circle'}
                style={{
                    color: hasRecord ? STATUS_COLOR_PALETTE.green : STATUS_COLOR_PALETTE.red,
                    fontSize: '16px'
                }}
            />
            {count > 1 ? `${count}x` : ''}
        </span>
    );
};
